<template>
	<div>
		<!-- 基本信息 -->
		<div class="inputList" v-if="isBasic">
			<labelInput :outInput="newform.declaration_unit" :spanRequired="true" normalPlace="请输入申报单位" 
			@inputChange="labelInput($event,'declaration_unit')"
				spanTitle="申报单位" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>
			<div style="width: 520px;">
			</div>

			<labelInput :outInput="newform.unit_address" :spanRequired="true" normalPlace="请输入单位地址" 
			@inputChange="labelInput($event,'unit_address')"
				spanTitle="单位地址" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>
			<div style="width: 520px;">
			</div>

			<labelInput :outInput="newform.group_name" :spanRequired="true" normalPlace="请输入小组名称" 
			@inputChange="labelInput($event,'group_name')"
				spanTitle="小组名称" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>
			<div style="width: 520px;">
			</div>

			<labelInput :outInput="newform.topic_name" :spanRequired="true" normalPlace="请输入课程名称" 
			@inputChange="labelInput($event,'topic_name')"
				spanTitle="课程名称" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>
			<div style="width: 520px;">
			</div>

			<normalSelect :outInput="newform.course_type" :spanRequired="true" pelaceHolder='请选择课程类型' 
			@selectCode="labelInput($event,'course_type')"
				:spanWidth="spanWidth" :dataList="installList" componentWidth="520px" spanTitle="课程类型">
			</normalSelect>
			<div style="width: 520px;">
			</div>

			<labelInput :outInput="newform.contacts_name" :spanRequired="true" normalPlace="请输入单位联系人姓名" 
			@inputChange="labelInput($event,'contacts_name')"
				spanTitle="单位联系人姓名" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>
			<labelInput :outInput="newform.contacts_cellphone" :spanRequired="true" normalPlace="请输入手机号" 
			@inputChange="labelInput($event,'contacts_cellphone')"
				spanTitle="联系人手机号" :spanWidth="spanWidth" componentWidth="520px" :isPhone="true" specilType='number'
				:maxLimit="11">
			</labelInput>
			<labelInput :outInput="newform.publisher" :spanRequired="true" normalPlace="请输入发布人姓名" 
			@inputChange="labelInput($event,'publisher')"
				spanTitle="发布人姓名" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>
			<labelInput :outInput="newform.publisher_phone" :spanRequired="true" normalPlace="请输入发布人手机号" 
			@inputChange="labelInput($event,'publisher_phone')"
				spanTitle="发布人手机号" :spanWidth="spanWidth" componentWidth="520px" :isPhone="true" specilType='number'
				:maxLimit="11">
			</labelInput>
			<labelInput :outInput="newform.post" :spanRequired="true" normalPlace="请输入获奖工程所从事职务"
			@inputChange="labelInput($event,'post')"
				spanTitle="获奖工程所从事职务" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>
			<labelInput :outInput="newform.tellphone" :spanRequired="true" normalPlace="请输入本人联系电话" 
			@inputChange="labelInput($event,'tellphone')"
				spanTitle="本人联系电话" :spanWidth="spanWidth" componentWidth="520px" :isPhone="true" specilType='number'
				:maxLimit="11">
			</labelInput>
			<labelInput :outInput="newform.introduction" :spanRequired="true" normalPlace="请输入小组简介" specilType="textarea"
				@inputChange="labelInput($event,'introduction')" :maxLimit="999" spanTitle="小组简介" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>
		</div>
		<!-- 获奖信息 -->
		<div class="awardInfo" v-else>
			<p class="view_head titleLeft">质量获奖情况</p>
			<labelInput :outInput="project_name1" :spanRequired="true" normalPlace="请输入工程名称" 
			@inputChange="labelInput2($event,'project_name','0')"
				spanTitle="工程名称" :spanWidth="spanWidth" componentWidth="90%">
			</labelInput>
			<labelInput :outInput="award_name1" :spanRequired="true" normalPlace="请输入获奖名称" 
			@inputChange="labelInput2($event,'award_name','0')"
				spanTitle="获奖名称" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>

			<normalPicker :outInput="award_time1" :spanRequired="true" pelaceHolder="请输入获奖时间" spanTitle="获奖时间" :spanWidth="spanWidth"
				@selectDate="labelInput2($event,'award_time','0')" componentWidth="520px">
			</normalPicker>

			<p class="view_head titleLeft">安全文明情况</p>
			<labelInput :outInput="project_name2" :spanRequired="true" normalPlace="请输入工程名称" 
			@inputChange="labelInput2($event,'project_name','1')"
				spanTitle="工程名称" :spanWidth="spanWidth" componentWidth="90%">
			</labelInput>
			<labelInput :outInput="award_name2" :spanRequired="true" normalPlace="请输入获奖名称" 
			@inputChange="labelInput2($event,'award_name','1')"
				spanTitle="获奖名称" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>

			<normalPicker :outInput="award_time2" :spanRequired="true" pelaceHolder="请输入获奖时间" spanTitle="获奖时间" :spanWidth="spanWidth"
				@selectDate="labelInput2($event,'award_time','1')" componentWidth="520px">
			</normalPicker>
		</div>
	</div>
</template>

<script>
	import {
		getCourseType,
	} from '../../../api/moudles/manager.js'
	import labelInput from '../../../components/table/labelInput.vue'
	import normalPicker from '../../../components/table/normalPicker.vue'
	import normalSelect from '../../../components/table/normalSelect.vue'
	export default {
		data() {
			return {
				project_name1:"",
				award_name1:'',
				award_time1:'',
				
				project_name2:"",
				award_name2:'',
				award_time2:'',
				
				spanWidth: '180px',
				newform:{},
				// 课程类型
				installList: [
					[]
				],
				form: {
					declaration_unit: '',
					unit_address: '',
					group_name: '',
					topic_name: '',
					course_type: '',
					contacts_name: '',
					contacts_cellphone: '',
					publisher: '',
					publisher_phone: '',
					post: '',
					tellphone: '',
					introduction: ''
				},
			}
		},
		props: {
			// 切换基本信息和获奖信息
			isBasic: {
				type: Boolean,
				default: true
			},
			basicMsg: {
				type: Object,
				default: () => {
					return {}
				}
			},
			awardMsg: {
				type: Array,
				default: () => {
					return []
				}
			}
		},
		watch: {
			req_num_code(newvalue, oldvalue) {
				this.$emit('req_num_code', newvalue)
			},
			basicMsg(newvalue) {
				this.newform = {
					...newvalue
				}
			},
			awardMsg(newvalue) {
				this.project_name1 = newvalue[0].project_name
				this.award_name1 = newvalue[0].award_name
				this.award_time1 = newvalue[0].award_time
				
				this.project_name2 = newvalue[1].project_name
				this.award_name2 = newvalue[1].award_name
				this.award_time2 = newvalue[1].award_time
			}
		},
		components: {
			labelInput,
			normalPicker,
			normalSelect
		},
		created() {
			if (this.isBasic) {
				this.$emit('basicInfo', this.form)
				this.getCourseType()
			}
		},
		methods: {
			// 获取课程类型下拉选项
			async getCourseType(){
				await getCourseType({
					data:{},
					success:res=>{
						const newArray = []
						for(let [key,value] of Object.entries(res.data)){
							const parmas = {}
							parmas.name = value
							parmas.code = key
							newArray.push(parmas)
						}
						this.$set(this.installList,0,newArray)
					}
				})
			},
			labelInput(e, name) {
				this.form[name] = e
				this.$emit('basicInfo', this.form)
			},
			labelInput2(e, name, id) {
				const params = [id, name, e]
				this.$emit('awardInfo', params)
			}
		}
	}
</script>

<style scoped>
	.inputList {
		display: flex;
		flex-wrap: wrap;
		margin-top: 20px;
	}

	.view_head {
		width: 100%;
		text-align: left;
		font-size: 18px;
		font-weight: 600;
		margin-top: 20px;
	}

	.titleLeft {
		margin-left: 50px;
	}

	.awardInfo {
		display: flex;
		flex-wrap: wrap;
		margin-top: 20px;
	}
</style>
